export default __webpack_public_path__ + "static/media/section-background.995bab82.png";